export default __webpack_public_path__ + "pypi/streamlit-1.37.1-cp312-none-any.whl";